import React from "react";
import "../../styles/facilitatorKRAView.scss";
import { useEffect } from "react";
import api from "../../utils/api";
import { useState } from "react";
import { toast } from "react-toastify";
import { getUser } from "../../utils/localStorage";
import { useHistory } from "react-router-dom";
import ReactDatePicker from "react-datepicker";
import Spinner from "../../common/Spinner/Spinner";
import { Button } from "../../common/Button/Button";
import FacilitatorKRAGrid from "../../components/FacilitatorKRADashboard/FacilitatorKRAGrid.jsx"


export default function FacilitatorKRADashboardContiner(props)
{
    let Report_data=[
        {
            key:"",
            reportType:"IHH",
            Title:"",
            target:"",
            actual:"",
            quality_analysis_fatal_details:"",
            service_instance_ids:"",
            handle_target:0,
            achieved:0,
            three_resourses_availed_user_emails:"",
            two_resourses_availed_user_emails:"",
        },
        {
            key:"total_ticket_assigned",
            reportType:"",
            Title:"Total tickets assigned",
            target:"NA",
            actual:"",
            quality_analysis_fatal_details:"",
            service_instance_ids:"",
            handle_target:0,
            achieved:0,
            three_resourses_availed_user_emails:"",
            two_resourses_availed_user_emails:"",
        },
        /*{
            key:"target",
            reportType:"",
            Title:"Target",
            target:"NA",
            actual:"",
            quality_analysis_fatal_details:"",
            service_instance_ids:"",
            handle_target:0,
            achieved:0,
            three_resourses_availed_user_emails:"",
        },*/
        /*{
            key:"targeted_vs_achieved",
            reportType:"",
            Title:"Target vs Achieved",
            target:"NA",
            actual:"",
            quality_analysis_fatal_details:"",
            service_instance_ids:"",
            handle_target:0,
            achieved:0,
            three_resourses_availed_user_emails:"",
        },*/
        {
            key:"total_ticket_unhandled",
            reportType:"",
            Title:"Unhandled tickets",
            target:"0",
            actual:"",
            quality_analysis_fatal_details:"",
            service_instance_ids:"",
            handle_target:0,
            achieved:0,
            three_resourses_availed_user_emails:"",
            two_resourses_availed_user_emails:"",
        },
        {
            key:"total_ticket_unhandled_per",
            reportType:"",
            Title:"% of unhandled tickets against total assigned tickets",
            target:"0%",
            actual:"",
            quality_analysis_fatal_details:"",
            service_instance_ids:"",
            handle_target:0,
            achieved:0,
            three_resourses_availed_user_emails:"",
            two_resourses_availed_user_emails:"",
        },
        {
            key:"system_updates_count",
            reportType:"",
            Title:"System updates (No. of leads not updated)",
            target:"0",
            actual:"",
            quality_analysis_fatal_details:"",
            service_instance_ids:"",
            handle_target:0,
            achieved:0,
            three_resourses_availed_user_emails:"",
            two_resourses_availed_user_emails:"",
        },
        {
            key:"quality_analysis_fatal_count",
            reportType:"",
            Title:"Quality Analysis (No. of Fatal calls)",
            target:"0",
            actual:"",
            quality_analysis_fatal_details:"",
            service_instance_ids:"",
            handle_target:0,
            achieved:0,
            three_resourses_availed_user_emails:"",
            two_resourses_availed_user_emails:"",
        },
        {
            key:"",
            reportType:"Engagement KRA",
            Title:"",
            target:"",
            actual:"",
            quality_analysis_fatal_details:"",
            service_instance_ids:"",
            handle_target:0,
            achieved:0,
            three_resourses_availed_user_emails:"",
            two_resourses_availed_user_emails:"",
        },
        {
            key:"assigned_customers",
            reportType:"",
            Title:"Assigned Service Requests",
            target:"",
            actual:"",
            quality_analysis_fatal_details:"",
            service_instance_ids:"",
            handle_target:0,
            achieved:0,
            three_resourses_availed_user_emails:"",
            two_resourses_availed_user_emails:"",
        },
        {
            key:"intro_call_done",
            reportType:"",
            Title:"Introductory call done",
            target:"100% of assigned Users",
            actual:"",
            quality_analysis_fatal_details:"",
            service_instance_ids:"",
            handle_target:0,
            achieved:0,
            three_resourses_availed_user_emails:"",
            two_resourses_availed_user_emails:"",
        },
        {
            key:"intro_call_not_done",
            reportType:"",
            Title:"Introductory call not done",
            target:"",
            actual:"",
            quality_analysis_fatal_details:"",
            service_instance_ids:"",
            handle_target:0,
            achieved:0,
            three_resourses_availed_user_emails:"",
            two_resourses_availed_user_emails:"",
        },
        {
            key:"deprenuer_listed_users",
            reportType:"",
            Title:"How many users listed on deprenuer listing page out of delivered in that period",
            target:"100% of delivered Users Nearer to 100%",
            actual:"",
            quality_analysis_fatal_details:"",
            service_instance_ids:"",
            handle_target:0,
            achieved:0,
            three_resourses_availed_user_emails:"",
            two_resourses_availed_user_emails:"",
        },
        {
            key:"challenges_shared_customer",
            reportType:"",
            Title:"How many users shared their challenged/goals with us  out of assigned in that period",
            target:"100% of assigned Users Nearer to 100%",
            actual:"",
            quality_analysis_fatal_details:"",
            service_instance_ids:"",
            handle_target:0,
            achieved:0,
            three_resourses_availed_user_emails:"",
            two_resourses_availed_user_emails:"",
        },
        {
            key:"stay_engaged_customer",
            reportType:"",
            Title:"How many users wants to stay engage with us out of delivered Users count",
            target:"",
            actual:"",
            quality_analysis_fatal_details:"",
            service_instance_ids:"",
            handle_target:0,
            achieved:0,
            three_resourses_availed_user_emails:"",
            two_resourses_availed_user_emails:"",
        },
        {
            key:"",
            reportType:"Offerings",
            Title:"",
            target:"",
            actual:"",
            quality_analysis_fatal_details:"",
            service_instance_ids:"",
            handle_target:0,
            achieved:0,
            three_resourses_availed_user_emails:"",
            two_resourses_availed_user_emails:"",
        },
        {
            key:"no_of_services_delivered_per_month_per",
            reportType:"",
            Title:"Target for a month (No of services delivered)",
            target:"45% of assigned services",
            actual:"",
            quality_analysis_fatal_details:"",
            service_instance_ids:"",
            handle_target:0,
            achieved:0,
            three_resourses_availed_user_emails:"",
            two_resourses_availed_user_emails:"",
        },
        {
            key:"services_delivered_month",
            reportType:"",
            Title:"No of services delivered in a month",
            target:"",
            actual:"",
            quality_analysis_fatal_details:"",
            service_instance_ids:"",
            handle_target:0,
            achieved:0,
            three_resourses_availed_user_emails:"",
            two_resourses_availed_user_emails:"",
        },
        {
            key:"delivered_targeted_vs_achieved",
            reportType:"",
            Title:"Delivered Services Target vs Achieved %",
            target:"NA",
            actual:"",
            quality_analysis_fatal_details:"",
            service_instance_ids:"",
            handle_target:0,
            graph_target:0,
            achieved:0,
            three_resourses_availed_user_emails:"",
        },
        /*{
            key:"no_of_users_availed_3_plus_services",
            reportType:"",
            Title:"Target for a month (No of Users availed 3+ resources)",
            target:"11 repeat users per month",
            actual:"",
            quality_analysis_fatal_details:"",
            service_instance_ids:"",
            handle_target:0,
            achieved:0,
            three_resourses_availed_user_emails:"",
        },*/
        {
            key:"two_resourses_availed_users",
            reportType:"",
            Title:"No of Users availed 2+ resources in a month",
            target:"NA",
            actual:"",
            quality_analysis_fatal_details:"",
            service_instance_ids:"",
            handle_target:0,
            achieved:0,
            three_resourses_availed_user_emails:"",
            two_resourses_availed_user_emails:"",
        },
        {
            key:"three_resourses_availed_users",
            reportType:"",
            Title:"No of Users availed 3+ resources in a month",
            target:"11 repeat users per month",
            actual:"",
            quality_analysis_fatal_details:"",
            service_instance_ids:"",
            handle_target:0,
            achieved:0,
            three_resourses_availed_user_emails:"",
            two_resourses_availed_user_emails:"",
        },
        {
            key:"three_plus_targeted_vs_achieved",
            reportType:"",
            Title:"Three+ resource availed users Target vs Achieved",
            target:"NA",
            actual:"",
            quality_analysis_fatal_details:"",
            service_instance_ids:"",
            handle_target:0,
            graph_target:0,
            achieved:0,
            three_resourses_availed_user_emails:"",
        },
    ];
    const [isLoading, setIsLoading] = useState(false);
    const[activePage,setActivePage]=useState(""); 
    const history = useHistory();
    const [selectedMonthForFilter, setMonthForFilter] = useState(new Date());
    const [KRAData, setKRAData] = useState(Report_data);

    useEffect(() => {
        if (!getUser()) 
        {
			history.push("/login");
		}
        else
        {
            const user = getUser();
            const hasFacilitatorRole = user.role.includes(3)||user.role.includes(4);
		    if (hasFacilitatorRole) 
            {
                setActivePage("KRAView");
                getESPServiceData();
            }
            else
            {
                setActivePage("No_Access");
            } 
        }
	},[]);

    
    const handleSearchClick = async () => {
        getESPServiceData();
	};

    const onClearFilterSearch = async () => {
	};

    const getESPServiceData=()=>{
        let filterParameters = {};
        
        var date = new Date(selectedMonthForFilter);
        var fromDate = new Date(date.getFullYear(), date.getMonth(), 1);
        var toDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);

        if(fromDate)
        {
            filterParameters.fromDate=fromDate;
        }

        if(toDate)
        {
            filterParameters.toDate=adjustedToDate(toDate);
        }

        let stesc=filterParameters;
        setIsLoading(true);	
        const { tempServices } = api.getFacilitatorKRADashboardData(filterParameters).then(({ data }) => {
            setIsLoading(false);
			if(data)
            {
                let KRA_data= Report_data.map((x) => 
                {
                   if(x.key&&data.hasOwnProperty(x.key)&&data[x.key].toString())
                   {
                    
                       if(x.key==='total_ticket_unhandled_per')
                       {
                            x.actual=parseFloat(data[x.key]).toFixed(2).toString()+'%';
                            x.quality_analysis_fatal_details=data['quality_analysis_fatal_details'].toString();
                            x.service_instance_ids=data['service_instance_ids'].toString();
                       }
                       else if(x.key==='no_of_services_delivered_per_month_per')
                       {
                            x.actual=parseFloat(data[x.key]).toFixed(2).toString()+'%';
                            x.quality_analysis_fatal_details=data['quality_analysis_fatal_details'].toString();
                            x.service_instance_ids=data['service_instance_ids'].toString();
                            x.target=(data["delivered_target"]?data["delivered_target"]+'% of assigned services':'NA')
                       }
                       else if(x.key==='three_resourses_availed_users')
                       {
                            x.actual=data[x.key].toString();
                            x.quality_analysis_fatal_details=data['quality_analysis_fatal_details'].toString();
                            x.service_instance_ids=data['service_instance_ids'].toString();
                            x.three_resourses_availed_user_emails=data['three_resourses_availed_user_emails'].toString().replace(/,/g, '\n');
                            x.target=(data["three_plus_user_target"]?data["three_plus_user_target"]+' repeat users per month':'NA')
                       }
                       else if(x.key==='two_resourses_availed_users')
                       {
                            x.actual=data[x.key].toString();
                            x.quality_analysis_fatal_details=data['quality_analysis_fatal_details'].toString();
                            x.service_instance_ids=data['service_instance_ids'].toString();
                            x.three_resourses_availed_user_emails=data['three_resourses_availed_user_emails'].toString().replace(/,/g, '\n');
                            x.two_resourses_availed_user_emails=data['two_resourses_availed_user_emails'].toString().replace(/,/g, '\n');
                            x.target=(data["two_plus_user_target"]?data["two_plus_user_target"]+' repeat users per month':'NA')
                       }
                       else
                       {
                            x.actual=data[x.key].toString();
                            x.quality_analysis_fatal_details=data['quality_analysis_fatal_details'].toString();
                            x.service_instance_ids=data['service_instance_ids'].toString();
                       }
                   }
                   else
                   {
                        //x.handle_target=parseInt(data['target'].toString());
                        //x.achieved=(parseInt(data['total_ticket_assigned'].toString())-parseInt(data['total_ticket_unhandled'].toString()));
                        if(x.key==='three_plus_targeted_vs_achieved')
                        {
                            x.graph_target=(data["three_plus_user_target"]||0)
                            x.achieved=(data["three_resourses_availed_users"]||0)
                        }
                        else if(x.key==='delivered_targeted_vs_achieved')
                        {
                            x.graph_target=(data["delivered_target"]||0)
                            x.achieved=(data["no_of_services_delivered_per_month_per"]||0)
                        }
                   }
                    return x;
                });
                setKRAData(KRA_data);
            }
            else
            {
                toast("Internal server error", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }
		}).catch((error) =>
        {
            setIsLoading(false);
            if(error.response.data.detail)
            {
                toast(String(error.response.data.detail), {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }
            else if(error.response.data.message)
            {
                toast(String(error.response.data.message), {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }
            else
            {
                toast("Internal server error", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }            
        });
    }

    const adjustedToDate = (date) => {
		let toDateAdjusted;
		if (date) {
			toDateAdjusted = new Date(date);

			toDateAdjusted = new Date(
				toDateAdjusted.setTime(
					toDateAdjusted.getTime() + 24 * 60 * 60 * 1000 - 1000
				)
			);
		}
		return toDateAdjusted;
	};

    const fetchKRADashboardReport = () => {
		
		try {
            let filterParameters = {};
            var date = new Date(selectedMonthForFilter);
            var fromDate = new Date(date.getFullYear(), date.getMonth(), 1);
            var toDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);

            if(fromDate)
            {
                filterParameters.fromDate=fromDate;
            }

            if(toDate)
            {
                filterParameters.toDate=adjustedToDate(toDate);
            }

            const user = getUser();
            const email = user.email;
            let facilitator_idsList = [];
            facilitator_idsList.push(email);
            filterParameters.facilitator_ids = facilitator_idsList;
            let sd=filterParameters;
            setIsLoading(true);
			api.getKRADashboardReport(filterParameters)
            .then(({ data }) => {
                toast(data["details"], {
                    autoClose: 5000,
                    type: toast.TYPE.SUCCESS,
                });
                window.open(data["generated_file"], "_self");
                setIsLoading(false);
            })
            .catch((error) => {
                setIsLoading(false);
                toast(error["response"]["data"]["message"], {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            });
		} catch (error) {
			setIsLoading(false);
			toast("Server error.", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
		}
	};

    const fetchFacilitatorCallReport = () => {		
		try 
        {
            let email=getUser().email;
            let filterParameters = {};
            if(!selectedMonthForFilter)
            {
                toast(`Please select Date.`, {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
                return;
            }
            var date = new Date(selectedMonthForFilter);
            var fromDate = new Date(date.getFullYear(), date.getMonth(), 1);
            var toDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);

            if(fromDate)
            {
                filterParameters.fromDate=fromDate;
            }

            if(toDate)
            {
                filterParameters.toDate=adjustedToDate(toDate);
            }

            filterParameters.facilitator_id = email;

            let sr=filterParameters
            setIsLoading(true);
            api.getFacilitatorCallReport(filterParameters)
                .then(({ data }) => {
                    setIsLoading(false);
                    toast(data["details"], {
                        autoClose: 5000,
                        type: toast.TYPE.SUCCESS,
                    });
                    window.open(data["generated_file"], "_self");
                    
                })
                .catch((error) => {
                    setIsLoading(false);
                    toast(error["response"]["data"]["message"], {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                });
            }
            catch (error)
            {
                setIsLoading(false);
                toast("Server error.", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
            });
        }
	};


    return(
        <>        
        {
            activePage==="KRAView"?
            (
                <div className={`${isLoading && "set-opacity"}`}>
                    {isLoading && <Spinner className="center-screen" />}
                    <div className="row">
                        <div className="col-1">

                        </div>
                        <div className="col-10">
                            <div className="row"style={{marginTop:"10px"}}>
                                <div className="col-12">                            
                                    <div className="fkra-report-date-picker">
                                        <ReactDatePicker
                                            dateFormat="MMM/yyyy"
                                            selected={selectedMonthForFilter}
                                            onChange={(date) =>setMonthForFilter(date)}
                                            placeholderText="select Month and Year"
                                            showMonthYearPicker
                                            maxDate={new Date()}
                                        />
                                    </div>
                                    <Button className="fkra-inline-button" onClick={handleSearchClick}>Search</Button>
                                    <Button className="fkra-inline-button" onClick={fetchKRADashboardReport}>Export</Button>
                                    {/*<Button className="fkra-inline-button" onClick={onClearFilterSearch}>
                                        Clear
                                    </Button>*/}
                                </div>
                            </div>
                            <div className="row"style={{marginTop:"20px"}}>
                                <div className="col-12 service-partner">
                                    <FacilitatorKRAGrid
                                        data={KRAData}
                                        fetchFacilitatorCallReport={fetchFacilitatorCallReport}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-1">

                        </div>
                    </div>
                    
                    
                </div>
            ):
            activePage==="No_Access"?
            (
                <div className={`row row-container`}>
                        <div className="col-12 row-margin-10px" style={{textAlign:"center"}}>                                
                        <label>
                            <b>You are not allowed to access this page, Please contact admin for more details.</b>
                        </label>         
                    </div>
                </div>
            )
            :
            (
                ""
            )}
        </>
    );
}